<template>
    <div class="chat-messages">
        <!-- <new-message v-if="showIconMessage" @scrollToBottom="scrollToBottom"></new-message> -->
        <div class="chat-container" 
             v-for="(message, index) in messages" :key="index" 
             :class="currentUser.id == message.sendlerId ? 'chat-container-right': ''">
            <div class="chat-message" 
                :class="defineClass(currentUser.id, message.sendlerId, message.typeMessage)"> 
                <span class="name-message" :style="{color : `${defineColor(message.sendlerId)}`}">
                    {{ currentUser.id == message.sendlerId ? '' : defineName(message.sendlerId, message.typeMessage, message.name) }}
                </span>
                <p class="message" v-html="message.message" v-if="message.typeMessage != 'new-player'">
                    <!-- {{ message.message }} -->
                </p>
                <!-- <span class="hour-message" v-if="message.typeMessage != 'new-player'">
                    {{formatHour(message.sentOn)}}
                </span> -->
            </div>
        </div>
    </div>
</template>
<script>
import NewMessage from './NewMessage.vue'
import scrollToBottomHelper from '../helpers/scrollToBottom.js'
import Bus from '../main.js'
import moment from 'moment'
moment.locale('pt-br');
export default {
    components:{
        NewMessage
    },
    props:{
        messages : {
            type : Array,
            required : true
        },
        currentUser : {
            required : true
        },
        group : {
            type : Array,
            required : true
        }
    },
    data(){
        return{
            showIconMessage : false
        }
    },
    created(){
        Bus.$on('scrollToBottomMessage', this.scrollToBottom)
    },
    mounted(){
        let chatMessages = document.querySelector('.chat-messages');
        let self = this
        chatMessages.addEventListener("scroll", function(){
            let scrollMax = 180
            let scrollElement = chatMessages.scrollTop
            let chatViewHeight = chatMessages.clientHeight
            let heightMax = chatMessages.clientHeight + 100
            if(chatMessages.scrollHeight - scrollElement >= heightMax){
                Bus.$emit('toggleIcon', true)
            }else{
                Bus.$emit('toggleIcon', false)
            }
        })
        chatMessages.scrollTo(0, chatMessages.scrollHeight)
        this.scrollToBottom()
    },
    methods : {
        defineClass(currentUser, sendlerId, typeMessage){
            let classes = ``
            if(currentUser == sendlerId){
                classes = classes + `message-right `
            }
            if(typeMessage == 'new-player'){
                classes = classes + `new-player-alert`
            }
            return classes
        },
        defineName(id, typeMessage, nameBot){
            if(typeMessage == 'new-player'){
                return nameBot
            }
            const {group} = this.$store.getters.getSimple(['group'])
            let memberMessage = group.filter(function(member){
                return member.id == id
            })
            let name = 'Huddle Brasil'
            if(memberMessage.length > 0){
                name = memberMessage[0].name
            }
            return name
        },
        defineColor(playerId){
            const {group} = this.$store.getters.getSimple(['group'])
            // let color = '#ff7300'
            let color = '#fff'
            const [ playerInGroup ] = group.filter(player => {
                return player.id == playerId
            })
            if(playerInGroup && playerInGroup.color){
                color = playerInGroup.color
            }
            return color
        },
        formatHour(data){
            return moment(data).format('HH:mm')
        },
        scrollToBottom(){
            let chatMessages = document.querySelector('.chat-messages');
            setTimeout(() => {
                // console.log(chatMessages.scrollHeight)
                chatMessages.scrollTo(0, chatMessages.scrollHeight)
            }, 200)
        }
    },
    
}
</script>
<style lang="scss">

</style>
